export default __webpack_public_path__ + "static/media/1-2-icon-his-icons-settings-2.39d0e451.svg";